<template>
  <div class="setHeightFullGrey">
    <div class="paddingbottom50">
      <van-divider v-show="list">
        <span class="text-lg">{{list.paperName}}</span>
      </van-divider>
      <div class="textCenter margin-tb-sm">
        <span
          class="text-sm text-red margin-lr-xs"
          v-show="list.paper_status==2"
        >{{list.total_score}}分</span>
        <van-tag
          v-if="list.paper_status==1"
          type="warning"
        >待出分</van-tag>
      </div>
      <div
        v-for="(item,index) in exam"
        :key="index"
      >
        <div v-if="item.questionType==0">
          <!-- 单选 -->
          <van-cell-group>
            <van-cell :title="(index+1)+'.【单选题】'+item.fldName">
              <div
                slot="right-icon"
                v-show="examStatu!=0"
              >
                <van-tag
                  type="success"
                  v-if="item.isTrue"
                >正确</van-tag>
                <van-tag
                  type="danger"
                  v-else
                >错误</van-tag>
              </div>
            </van-cell>
            <div
              class="marginBottomXm"
              v-for="(radios, indexSon) in item.QuestionOptionList"
              :key="indexSon"
            >
              <div v-show="examStatu!=0">
                <van-cell
                  v-show="radios.checked"
                  center
                  size="mini"
                  :border="false"
                  title=""
                  :label="radios.fldOptionText"
                >
                  <van-icon
                    slot="right-icon"
                    :name="checkboxSelectedDisable"
                    style="line-height: inherit;"
                  />
                </van-cell>
                <van-cell
                  v-show="!radios.checked"
                  center
                  size="mini"
                  :border="false"
                  title=""
                  :label="radios.fldOptionText"
                >
                  <van-icon
                    slot="right-icon"
                    :name="checkboxDisabled"
                    style="line-height: inherit;"
                  />
                </van-cell>
              </div>
              <div v-show="examStatu==0">
                <van-cell
                  v-show="radios.checked"
                  @click="radioChange(radios,indexSon,index)"
                  center
                  size="mini"
                  :border="false"
                  title=""
                  :label="radios.fldOptionText"
                >
                  <van-icon
                    slot="right-icon"
                    :name="checkboxSelected"
                    style="line-height: inherit;"
                  />
                </van-cell>
                <van-cell
                  v-show="!radios.checked"
                  @click="radioChange(radios,indexSon,index)"
                  center
                  size="mini"
                  :border="false"
                  title=""
                  :label="radios.fldOptionText"
                >
                  <van-icon
                    slot="right-icon"
                    :name="checkboxUnSelected"
                    style="line-height: inherit;"
                  />
                </van-cell>
              </div>
            </div>
          </van-cell-group>
        </div>
        <div v-else-if="item.questionType==1">
          <!-- 多选 -->
          <van-cell-group>
            <van-cell :title="(index+1)+'.【多选题】'+item.fldName">
              <div
                slot="right-icon"
                v-show="examStatu!=0"
              >
                <van-tag
                  type="success"
                  v-if="item.isTrue"
                >正确</van-tag>
                <van-tag
                  type="danger"
                  v-else
                >错误</van-tag>
              </div>
            </van-cell>
            <div
              class="marginBottomXm"
              v-for="(radios, indexSon) in item.QuestionOptionList"
              :key="indexSon"
            >
              <div v-show="examStatu!=0">
                <van-cell
                  v-if="radios.checked"
                  center
                  size="mini"
                  :border="false"
                  title=""
                  :label="radios.fldOptionText"
                >
                  <van-icon
                    slot="right-icon"
                    :name="checkboxSelectedDisable"
                    style="line-height: inherit;"
                  />
                </van-cell>
                <van-cell
                  v-if="!radios.checked"
                  center
                  size="mini"
                  :border="false"
                  title=""
                  :label="radios.fldOptionText"
                >
                  <van-icon
                    slot="right-icon"
                    :name="checkboxDisabled"
                    style="line-height: inherit;"
                  />
                </van-cell>
              </div>
              <div v-show="examStatu==0">
                <van-cell
                  v-if="radios.checked"
                  @click="checkboxChange(radios,indexSon,index)"
                  center
                  size="mini"
                  :border="false"
                  title=""
                  :label="radios.fldOptionText"
                >
                  <van-icon
                    slot="right-icon"
                    :name="checkboxSelected"
                    style="line-height: inherit;"
                  />
                </van-cell>
                <van-cell
                  v-if="!radios.checked"
                  @click="checkboxChange(radios,indexSon,index)"
                  center
                  size="mini"
                  :border="false"
                  title=""
                  :label="radios.fldOptionText"
                >
                  <van-icon
                    slot="right-icon"
                    :name="checkboxUnSelected"
                    style="line-height: inherit;"
                  />
                </van-cell>
              </div>

            </div>
          </van-cell-group>
        </div>
        <div v-else-if="item.questionType==2">
          <van-cell
            slot="right-icon"
            :title="(index+1)+'.【填空题】'+item.fldName"
          >
          </van-cell>
          <van-cell-group>
            <div
              class="marginBottomXm"
              v-for="(radios, indexSon) in item.QuestionOptionList"
              :key="indexSon"
            >
              <van-cell
                center
                size="mini"
                :border="false"
                title=""
                :label="radios.fldOptionText"
              />
              <van-field
                v-if="examStatu==0"
                rows="3"
                autosize
                type="textarea"
                placeholder="请输入内容"
                v-model="exam[index].QuestionOptionList[indexSon].textarea"
              />
              <van-field
                v-else
                rows="3"
                autosize
                type="textarea"
                disabled=""
                placeholder="请输入内容"
                :value="item.fldAnswer[0]"
              />
            </div>
          </van-cell-group>
        </div>

        <div
          class="margin-tb-sm  text-gray padding-xs"
          v-show="examStatu!=0"
        >
          参考答案:<span class="text-red">{{item.analysis}}</span>
        </div>
      </div>

    </div>
    <button
      class="fixBottom cu-btn bg-green text-white bg-shadow lg"
      style="position: fixed;"
      @click="apply"
      v-show="examStatu==0"
    >
      <span>交卷</span>
      <span class="text-sm margin-lr-xs">{{showTime}}</span>
    </button>

    <input
      type="hidden"
      v-model="test"
    >
  </div>
</template>

<script>
export default {
  data() {
    return {
      hour: 0,
      minute: 0,
      second: 0,
      millisecond: 0,
      time: 30 * 60 * 1000,
      list: [],
      checkboxSelectedDisable: this.$mAssetsPath.checkboxSelectedDisable,
      checkboxDisabled: this.$mAssetsPath.checkboxDisabled,
      checkboxSelected: this.$mAssetsPath.checkboxSelected,
      checkboxUnSelected: this.$mAssetsPath.checkboxUnSelected,
      exam: null,
      test: '哈哈哈',
      start_time: '',
      showTime: '00:00',
      id: '',
      examStatu: null,
    }
  },
  watch: {},
  created() {
    const that = this
    that.loadExam()
    setInterval(function () {
      that.timer()
    }, 1000)
    that.start_time = new Date().Format('yyyy-MM-dd HH:mm:ss')
  },
  methods: {
    loadExam() {
      const that = this
      that.id = that.$route.query.id
      try {
        that.$axios.get('exam/subjectlist?exam_id=' + this.id).then((res) => {
          if (res.data.code == 200) {
            that.list = res.data.data.exam_list
            that.examStatu = parseInt(that.list.paper_status)
            let data = that.list
            if (that.examStatu != 0) {
              for (let i in data.QuestionList) {
                data.QuestionList[i].isTrue =
                  data.QuestionList[i].fldTrueAnswer.toString() ==
                  data.QuestionList[i].fldAnswer.toString()
                var analysis = ''
                for (let j in data.QuestionList[i].fldTrueAnswer) {
                  analysis += that.checkNum(
                    data.QuestionList[i].fldTrueAnswer[j]
                  )
                  //nameArr.join(",")
                }
                data.QuestionList[i].analysis = analysis
              }
            }
            let time = res.data.data.exam_list.count_down
            // this.time=time* 60 * 60 * 1000;
            that.loadData(data.QuestionList)
          } else {
            that.$toast(res.data.msg)
          }
        })
      } catch (e) {
        if (this.$mConfig.debug) {
          console.log(e)
        }
      }
    },
    timer() {
      const that = this
      that.second++
      if (that.second >= 60) {
        that.second = 0
        that.minute = that.minute + 1
      }

      if (that.minute >= 60) {
        that.minute = 0
        that.hour = that.hour + 1
      }
      that.showTime = that.toDub(that.minute) + ':' + that.toDub(that.second)
    },
    toDub(n) {
      return n < 10 ? '0' + n : '' + n
    },
    isRepeat(arr) {
      var hash = {}
      for (var i in arr) {
        if (hash[arr[i]]) return true
        hash[arr[i]] = true
      }
      return false
    },
    apply() {
      let subject_list = []
      const that = this
      let flag = 0
      that.$toast.loading({
        message: '交卷中',
        forbidClick: true,
      })
      for (let i in that.exam) {
        let answers = []
        for (let j in that.exam[i].QuestionOptionList) {
          if (that.exam[i].QuestionOptionList[j].checked) {
            answers.push(that.exam[i].QuestionOptionList[j].optionID)
          }
          if (that.exam[i].questionType == 2) {
            that.exam[i].QuestionOptionList[0].textarea
              ? (answers = [that.exam[i].QuestionOptionList[0].textarea])
              : (answers = [])
          }
        }
        subject_list.push({
          subject_id: that.exam[i].questionID,
          answers: answers,
        })
      }
      for (let i in subject_list) {
        if (subject_list[i].answers.length == 0) {
          flag++
        }
      }
      console.log(flag)
      let query = {
        answer: {
          exam_id: this.list.fldGuid,
          start_time: this.start_time,
          subject_list: subject_list,
        },
      }
      if (flag != 0) {
        that.$toast.clear()
        that.$dialog.confirm({
          title: '提示',
          message: '您有' + flag + '道题目未作答',
          showCancelButton: false,
        })
      } else {
        that.$toast.clear()
        that.$axios.post('/exam/upexam', query).then((res) => {
          console.log(res)
          if (res.data.code == 200) {
            that.$dialog
              .confirm({
                title: '提示',
                message: '交卷成功',
                showCancelButton: false,
              })
              .then(() => {
                that.$router.go(-1)
              })
          } else {
            that.$oast.fail(res.data.msg)
          }
        })
      }
    },
    overTime() {
      const that = this
      this.$dialog
        .confirm({
          title: '提示',
          message: '考试时间已结束,是否交卷',
        })
        .then((res) => {
          console.log(res)
        })
        .catch(() => {
          that.$router.go(-1)
        })
    },
    radioChange(value, detaulIndex, index) {
      const that = this
      for (let i in that.exam[index]) {
        for (let j in that.exam[index].QuestionOptionList) {
          that.exam[index].QuestionOptionList[j].checked = false
        }
      }
      that.exam[index].QuestionOptionList[detaulIndex].checked = true
      that.test = Math.random()
    },
    checkboxChange(value, detaulIndex, index) {
      const that = this

      that.exam[index].QuestionOptionList[detaulIndex].checked =
        !that.exam[index].QuestionOptionList[detaulIndex].checked
      that.test = Math.random()
    },
    checkNum(num) {
      //把数字转换为字母
      if (typeof num == 'number')
        return String.fromCharCode(0x60 + num).toUpperCase()
      else return num
    },
    takeInit(data) {},
    loadData(value) {
      const that = this
      let data = value
      for (let i in data) {
        if (data[i].questionType == 0 || data[i].questionType == 1) {
          for (let j in data[i].QuestionOptionList) {
            let word = String.fromCharCode(0x60 + parseInt(j) + 1).toUpperCase()
            data[i].QuestionOptionList[j].fldOptionText =
              word + ':' + data[i].QuestionOptionList[j].fldOptionText
            data[i].QuestionOptionList[j].checked = false
            if (data[i].fldAnswer) {
              for (let q in data[i].fldAnswer) {
                if (
                  data[i].QuestionOptionList[j].fldOptionIndex ==
                  data[i].fldAnswer[q]
                ) {
                  data[i].QuestionOptionList[j].checked = true
                }
              }
            }
          }
        } else if (data[i].questionType == 2) {
          // 填空
        }
      }
      this.exam = data
    },
  },
}
</script>

<style scoped>
@import '../../../colorui/main.css';
</style>
